<template>
  <div class="view">
    <h1 class="u-visually-hidden">Jaeger-LeCoultre</h1>
    <Loader v-if="loading || chaptersLoading || storiesLoading" />
    <transition name="fade">
      <template  v-if="!loading && !chaptersLoading && !storiesLoading">
        <div class="container">
          <HomeHeading />
          <user-progress
              :user="user"
              :storiesNbr="stories.length"
              :shareAvailable="shareAvailable"
              @displayShare="toggleModal('shareDisplayed')"
            />
          <spacer />
          <div class="view-chapters">
            <h2 class="h3">{{ $t('home.chapters_title') }}</h2>
            <slider
              :slides="chapters"
            />
            <spacer />
          </div>
          <div class="view-stories">
            <div
              v-for="(chapter, index) in chaptersWithStories"
              :key="`chapters-${chapter.id}-${index}`">
              <h2 class="h3" v-html="chapter.title"></h2>
              <slider
                :isStories="true"
                :slides="getStoriesByChapter(chapter.id)"
              />
              <spacer v-if="index !== chaptersWithStories.length - 1" />
            </div>
          </div>
        </div>
      </template>
     </transition>
      <modal
      :isDisplayed="shareDisplayed"
      :id="'modal-share'"
      :title="$t('share.modal_title')"
      @closeModal="toggleModal('shareDisplayed')">
      <share
        :user="user"
        :storiesNbr="stories.length"
      />
    </modal>
  </div>
</template>

<script>

import UserProgress from '@/components/partials/UserProgress.vue';
import HomeHeading from '@/components/HomeHeading.vue'
import Loader from '@/components/components/Loader.vue';
import Share from '@/components/partials/Share.vue';
import Spacer from '@/components/components/Spacer.vue';
import Slider from '@/components/partials/Slider.vue';
import Modal from '@/components/partials/Modal.vue';
import toggleModal from '@/mixins/toggleModal';

export default {
  components: {
    Loader,
    Spacer,
    Slider,
    HomeHeading,
    UserProgress,
    Modal,
    Share
  },
  mixins: [toggleModal],
  async beforeMount() {
    // await this.$store.dispatch('login/refreshToken');
    const { locale } = this.$route.params;
    const exhibitionId = this.$route.params.id;
    if (!this.$store.state.exhibitions.item || this.$store.state.exhibitions.item.id !== exhibitionId) {
      this.$store.dispatch('exhibitions/getDetail', { id: exhibitionId, loc: locale });
    }
    if (!this.$store.state.user.item) {
      this.$store.dispatch('user/get', exhibitionId);
    }
    if (this.$store.state.chapters.items.length === 0) {
      this.$store.dispatch('chapters/get', { id: exhibitionId, loc: locale });
    }
    if (this.$store.state.stories.items.length === 0) {
      this.$store.dispatch('stories/get', { id: exhibitionId, loc: locale });
    }
    if (!this.$store.state.terms.item) {
      this.$store.dispatch('terms/get', locale);
    }
    this.checkShareAvailable();
  },
  computed: {
    user() {
      return this.$store.state.user.item;
    },
    userLoading() {
      return this.$store.state.user.requests !== 0;
    },
    loading() {
      return this.$store.state.exhibitions.requests !== 0;
    },
    chapters() {
      return this.$store.state.chapters.items;
    },
    chaptersWithStories() {
      return this.chapters.filter(c => this.getStoriesByChapter(c.id).length > 0);
    },
    chaptersLoading() {
      return this.$store.state.chapters.requests !== 0;
    },
    stories() {
      return this.$store.state.stories.items;
    },
    storiesLoading() {
      return this.$store.state.stories.requests !== 0;
    },
    terms() {
      return this.$store.state.terms.item;
    },
    termsLoading() {
      return this.$store.state.terms.requests !== 0;
    },
  },
  data() {
    return {
      shareDisplayed: false,
      termsDisplayed: false,
      leaderboardDisplayed: false,
      shareAvailable: true
    };
  },
  watch: {
    $route(newRoute) {
      const { locale } = newRoute.params;

      const exhibitionId = newRoute.params.id;
      this.$store.dispatch('exhibitions/getDetail', { id: exhibitionId, loc: locale });

      
      this.$store.dispatch('terms/get', locale);
    },
  },
  methods: {
    getStoriesByChapter(id) {
      return this.stories.filter(s => s.chapter_id === id);
    },
    checkShareAvailable() {
      if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        const iOS = this.iOSversion();
        if (iOS.status === true && iOS.version < 15) {
          this.shareAvailable = false;
        }
      }
    },
    iOSversion() {
      let d;
      let v;
      if (/iP(hone|od|ad)/.test(navigator.platform)) {
        v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        d = {
          status: true,
          version: parseInt(v[1], 10),
          info: parseInt(v[1], 10) + parseInt(v[2], 10) + parseInt(v[3] || 0, 10)
        };
      } else {
        d = { status: false, version: false, info: '' };
      }
      return d;
    },
        getTo(name) {
      const locale = localStorage.getItem('lang') || 'ko';
      return `/${locale}/${name}`;
    },
  }
};
</script>

<style lang="scss" scoped>
.view {
  padding-top: 65px;
  background-color: $primary;

  &-head {
    &-title {
      @include margin(null null 10px);
      line-height: 1.1;
    }
    &-text {
      color: rgba($tertiary, .5);
    }
    .btn.transparent {
      @include margin(10px null null);
      display: block;
      width: 100%;
    }
  }

  &-stories {
    @include margin(null null 55px);
    &-title {
      @include margin(null null 20px);
    }
  }

  .slider {
    @include margin(10px null null);
  }

  .modal-terms-button {
    width: 100%;
    @include margin(20px 0 0);
    @include font('primary', 'bold');
    @include padding(17px 20px 15px);
    position: relative;
    display: inline-block;
    border: 1px solid $primary;
    border-radius: 24px;
    outline: none;
    background-color: $primary;
    color: $tertiary;
    font-size: rem(12px);
    line-height: 1;
    text-align: center;
    text-transform: uppercase;
  }

  // Loader
  // -----------------------------------------------------------------------------
  .loader {
    @include position(absolute, 50% null null 50%);
    transform: translate(-50%, -50%);
  }
}
</style>
